var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.835 17.4826L17.3021 23.0155C14.6506 25.667 10.3517 25.667 7.70014 23.0155C5.04863 20.364 5.04863 16.065 7.70014 13.4135L15.1478 5.96583C16.9168 4.19681 19.785 4.19681 21.554 5.96583C23.323 7.73486 23.323 10.603 21.554 12.372L13.8717 20.0543C13.0406 20.8855 11.693 20.8855 10.8618 20.0543C10.0307 19.2232 10.0307 17.8756 10.8618 17.0445L16.6293 11.277C16.9222 10.9841 16.9222 10.5092 16.6293 10.2163C16.3364 9.92342 15.8616 9.92342 15.5687 10.2163L9.80119 15.9838C8.38425 17.4007 8.38425 19.698 9.80119 21.115C11.2181 22.5319 13.5154 22.5319 14.9324 21.115L22.6147 13.4327C24.9695 11.0779 24.9695 7.25998 22.6147 4.90517C20.2598 2.55037 16.442 2.55037 14.0871 4.90517L6.63948 12.3528C3.40218 15.5901 3.40218 20.8388 6.63948 24.0761C9.87678 27.3134 15.1255 27.3134 18.3628 24.0761L23.8956 18.5433C24.1885 18.2504 24.1885 17.7755 23.8956 17.4826C23.6027 17.1897 23.1279 17.1897 22.835 17.4826Z",
    fill: "#9A9A9A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachIcon);
export default __webpack_public_path__ + "static/media/attach_icon.f16911acb247056634e70ae8d6ca60b2.svg";
export { ForwardRef as ReactComponent };